// extracted by mini-css-extract-plugin
module.exports = {"card":"PersonCard_card__1vjAG","details":"PersonCard_details__5Ejxj","name":"PersonCard_name__q5V4T","capacity":"PersonCard_capacity__qGPYN","email":"PersonCard_email__fR2i5"};